<mat-form-field class="custom-input-container" appearance="outline">
  <button mat-icon-button matPrefix (click)="decrement()" [disabled]="disabled">
    <mat-icon>remove</mat-icon>
  </button>
  <input matInput disabled type="number" min="minValue" max="maxValue" [(ngModel)]="counter">
  <button mat-icon-button matSuffix (click)="increment()" [disabled]="disabled">
    <mat-icon>add</mat-icon>
  </button>
</mat-form-field>
